<template>
  <div
    :role="variant === StateVariant.ERROR ? 'alert' : 'status'"
    :aria-live="variant === StateVariant.ERROR ? 'assertive' : 'polite'"
    class="flex flex-col items-center justify-center text-center w-full max-w-[402px] gap-4 p-6 md:max-w-[480px] md:gap-0 md:p-0"
  >
    <div class="flex flex-col items-center w-full">
      <slot name="illustration">
        <StateIllustration :illustration="illustration" />
      </slot>
    </div>
    <div class="flex flex-col gap-6 items-center w-full">
      <div
        class="flex flex-col gap-2 items-center justify-center w-full break-words"
      >
        <p class="font-bold text-2xl leading-8 text-on-surface w-full">
          {{ header }}
        </p>
        <p
          v-if="subheader"
          class="font-normal text-base leading-6 text-on-surface-variant w-full"
        >
          {{ subheader }}
        </p>
      </div>
      <div
        v-if="$slots.actions || primaryCtaLabel || secondaryCtaLabel"
        class="flex flex-col gap-4 items-center justify-center w-full md:flex-row md:gap-6"
      >
        <slot name="actions">
          <Button
            v-if="secondaryCtaLabel"
            :label="secondaryCtaLabel"
            :variant="ButtonVariant.TEXT"
            :color="ButtonColor.SECONDARY"
            :size="ButtonSize.SM"
            class="w-full md:w-auto"
            @click="emit('secondaryClick')"
          />
          <Button
            v-if="primaryCtaLabel"
            :label="primaryCtaLabel"
            :size="ButtonSize.SM"
            class="w-full md:w-auto"
            @click="emit('primaryClick')"
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
} from '@exfluential/ui';
import { StateVariant, IllustrationVariant } from './state-container.constants';
import StateIllustration from './StateIllustration.vue';

type Props = {
  variant?: StateVariant;
  illustration?: IllustrationVariant;
  header: string;
  subheader?: string;
  primaryCtaLabel?: string;
  secondaryCtaLabel?: string;
};

withDefaults(defineProps<Props>(), {
  variant: StateVariant.EMPTY,
});

const emit = defineEmits<{
  (e: 'primaryClick'): void;
  (e: 'secondaryClick'): void;
}>();
</script>
